import React, { useEffect } from 'react'
import ImportantNoteOTS from './ImportantNoteOTS'
import { useDispatch, useSelector } from 'react-redux';
import { getCommission } from '../../../redux/master/action';

// publish_project
// create_contest
// posting_jobs
// hiring
// create_bxp
// publish_sale
// create_rental
// post_auction

export default function CommissionNote({ type, item }) {
    const commissiondetails = useSelector(({ master: { commissiondetails } }) => commissiondetails);
    const dispatch = useDispatch()

    useEffect(() => {
        if (type) {
            dispatch(getCommission(type));
        }
    }, [type]);

    return (
        <ImportantNoteOTS commission={commissiondetails?.commission} item={item} />
    )
}
